import { IAppState } from '../../redux';
import { IOfferHomeowner } from '../../redux/reducers';

export const selectHomeowner = (state: IAppState): IOfferHomeowner | null => state.offer.homeOwner;
